import React from "react";
import { Link } from "react-router-dom";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { pageVisual, TILE_TONES } from "../homeIcons";

// Fallback widget for pages without a custom summary: a tile-sized shortcut.
// Every page in the favorites catalog gets one of these automatically, so a
// newly added page is widget-ready with zero extra work (add a live widget
// in registry.js when the page has data worth summarizing).
const GenericPageWidget = ({ page }) => {
  const { icon: Icon, tone } = pageVisual(page.path, page.group);
  return (
    <Link
      to={page.path}
      className="app-card group flex h-full min-h-[9.5rem] flex-col justify-between rounded-2xl border p-4 transition duration-200 hover:-translate-y-0.5 hover:border-sky-400/50"
    >
      <div className="flex items-start gap-3">
        <span className={`app-icon-tile ${TILE_TONES[tone] || TILE_TONES.slate}`}>
          <Icon />
        </span>
        <div className="min-w-0">
          <p className="app-eyebrow truncate">{page.group}</p>
          <h3 className="mt-0.5 font-semibold leading-snug tracking-tight">
            {page.name}
          </h3>
        </div>
      </div>
      <span className="app-muted mt-4 inline-flex items-center gap-1 text-sm font-medium transition-colors group-hover:text-[color:var(--app-accent)]">
        Open page
        <ArrowForwardRoundedIcon
          className="transition group-hover:translate-x-0.5"
          sx={{ fontSize: 16 }}
        />
      </span>
    </Link>
  );
};

export default GenericPageWidget;
